import currentDevice from 'current-device';

export interface IDeviceDetector {
	isMobile: () => boolean
	isDesktop: () => boolean
	isIOS: () => boolean
}

class DeviceDetector implements IDeviceDetector {
	isMobile():boolean {
		return currentDevice.mobile();
	}

	isDesktop():boolean {
		return currentDevice.desktop();
	}

	isIOS():boolean {
		return currentDevice.ios();
	}
}

export const device =  new DeviceDetector();